import { memo, useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Tooltip } from 'hoi-poi-ui';
import { ConfigActions } from 'actions';
import { ACTIVITIES, AGENDA } from 'constants/Entities';
import { SynchronizeService } from 'services';
import { getLiteral } from 'utils/getLiteral';
import { ensureRoute } from 'utils/routes';

const EnableSync = memo(({ entity }) => {
    const dispatch = useDispatch();
    const { email, productModeCode, subscriptionModeCode, syncEmailWithNylasPermissions } =
        useSelector((state) => ({
            email: state?.config?.userData?.email,
            syncEmailWithNylasPermissions: state?.config?.userData?.syncEmailWithNylasPermissions,
            subscriptionModeCode: state?.config?.subscriptionModeCode,
            license: state?.config?.license,
            productModeCode: state?.config?.productModeCode,
        }));
    const [isSynced, setIsSynced] = useState(true);

    const handleClick = () => {
        ensureRoute('/settings/nylas');
    };

    useEffect(() => {
        SynchronizeService.getAccount(email)
            .then((data) => {
                if (data?.calendar.enabled && data?.mail.enabled) setIsSynced(true);
                else setIsSynced(false);

                // Set email permissions in userData
                const mail = data.mail;
                const emailPermissions = mail?.enabled && mail?.enabledSend;
                if (emailPermissions !== syncEmailWithNylasPermissions) {
                    dispatch(
                        ConfigActions.updateUserDataConfiguration({
                            syncEmailWithNylasPermissions: emailPermissions,
                            syncEmailWithNylasStatus: data?.account?.status || 0,
                        }),
                    );
                }
            })
            .catch((e) => {
                if (e?.data?.code === 405) {
                    setIsSynced(false);
                }
            });
    }, [dispatch, email, syncEmailWithNylasPermissions]);

    const shouldRenderButton = useMemo(() => {
        if (
            !isSynced &&
            (entity === ACTIVITIES || entity === AGENDA) &&
            (['starter', 'essential'].includes(productModeCode) ||
                subscriptionModeCode === 'free_trial')
        )
            return true;
        else return false;
    }, [isSynced, entity, productModeCode, subscriptionModeCode]);

    if (!shouldRenderButton) return null;

    return (
        <Tooltip placement="top" content={getLiteral('label_enable_sync_email_calendar_web')}>
            <Button
                type="terciary"
                size="medium"
                icon="syncCalendar"
                className="fm-enable-sync__button"
                onClick={handleClick}
            />
        </Tooltip>
    );
});

export default EnableSync;
